export const validateEmail = (email) => {
  var validated = /^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,63})+$/.test(email);
  if (!validated) {
    return false;
  }
  return true;
};

export const validatePassword = (password) => {
  // minimum 8 characters, at least one capital letter and one number
  if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,254}$/.test(password)) {
    return true;
  }
  return false;
};

export const validateNotEmpty = (value) => {
  var validated = value.length > 0;
  if (!validated) {
    return false;
  }
  return true;
};

export const validateFile = (file) => {
  if (!file) {
    return true;
  }
  if (file.size > 500000) {
    return false;
  }

  if (
    file.type === 'image/png' ||
    file.type === 'image/jpg' ||
    file.type === 'image/jpeg' ||
    file.type === 'application/pdf'
  ) {
    return true;
  } else {
    return false;
  }
};
